import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Tenant } from '@/app/app/interfaces/api/tenant';
import { environment } from '@/app/environments/environment';
import { Hierarchical } from '@/shared/lib/core/utils/hierarchical';

@Service()
export class TenantsApi {
  http = inject(HttpClient);

  public getTenantByHeader(): Observable<Tenant[]> {
    return this.http.get<Tenant[]>(`${environment.data.baseUrl}/tenants/byheader`).pipe(map(result => {
      return result && result.length
        ? Hierarchical.sortByLevel(result)
        : result;
    }));
  }

}
